import requireEnv from './requireEnv';

// All config that depends on environment variables
export const AUTH_API = requireEnv('REACT_APP_AUTH_API');
export const SUPPORT_API = requireEnv('REACT_APP_SUPPORT_API');
export const APP_VERSION = requireEnv('REACT_APP_VERSION', 'dev');
